import { render } from "./DetailTabs.vue?vue&type=template&id=6813e038&scoped=true"
import script from "./DetailTabs.vue?vue&type=script&lang=js"
export * from "./DetailTabs.vue?vue&type=script&lang=js"

import "./DetailTabs.vue?vue&type=style&index=0&id=6813e038&scoped=true&lang=css"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6813e038"],['__file',"DetailTabs.vue"]])

export default __exports__